export default __webpack_public_path__ + "static/media/icon_result_3.6d788671.svg";